const typeFiles: Record<string, string> = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'application/xlsx',
  'application/vnd.ms-excel': 'application/xls',
  'application/pdf': 'application/pdf',
  'application/msword': 'application/doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'application/docx',
  'application/vnd.ms-powerpoint': 'application/ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'application/pptx',
  'application/zip': 'application/zip',
  'text/plain': 'application/txt',
  'text/csv': 'application/csv',
  'video/x-matroska': 'video/mkv',
  'video/mp4': 'video/mp4',
  'video/x-ms-wmv': 'video/wmv',
  'audio/x-ms-wma': 'audio/wma',
  'video/x-flv': 'video/flv',
  'video/quicktime': 'video/mov',
  'video/webm': 'video/webm',
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/gif': 'image/gif',
  'image/bmp': 'image/bmp',
  'image/webp': 'image/webp',
  'image/svg+xml': 'image/svg',
  'image/tiff': 'image/tiff',
  'application/x-rar-compressed': 'application/rar',
  'audio/mpeg': 'audio/mp3',
  'audio/ogg': 'audio/ogg',
  'audio/wav': 'audio/wav',
  'audio/aac': 'audio/aac',
  'audio/x-aiff': 'audio/aiff',
  'audio/x-flac': 'audio/flac',
  'application/x-shockwave-flash': 'application/swf',
  'application/x-msdownload': 'application/exe',
  'application/vnd.android.package-archive': 'application/apk',
  'application/json': 'application/json',
  'application/javascript': 'application/js',
  'application/xml': 'application/xml',
  'text/html': 'application/html',
  'application/x-tar': 'application/tar',
  'application/gzip': 'application/gz',
  'application/x-7z-compressed': 'application/7z',
  'application/vnd.oasis.opendocument.text': 'application/odt',
  'application/vnd.oasis.opendocument.spreadsheet': 'application/ods',
  'application/vnd.oasis.opendocument.presentation': 'application/odp',
  'application/vnd.ms-visio.drawing': 'application/vsd',
  'application/vnd.ms-visio.viewer': 'application/vsdx',
  'application/x-font-woff': 'application/woff',
  'application/x-font-woff2': 'application/woff2',
  'font/otf': 'font/otf',
  'font/ttf': 'font/ttf',
  'application/epub+zip': 'application/epub',
  'application/x-font-ttf': 'application/ttf',
  'application/x-mspublisher': 'application/mspub',
  'application/vnd.ms-access': 'application/mdb',
};


const extentions = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  zip: 'application/zip',
  txt: 'text/plain',
  csv: 'text/csv',
  mkv: 'video/x-matroska',
  mp4: 'video/mp4',
  wmv: 'video/x-ms-wmv',
  wma: 'audio/x-ms-wma',
  flv: 'video/x-flv',
  mov: 'video/quicktime',
  webm: 'video/webm',
}

const filesToType: Record<string, string> = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-excel': 'xls',
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/zip': 'zip',
  'text/plain': 'txt',
  'text/csv': 'csv',
  'video/x-matroska': 'mkv',
  'video/mp4': 'mp4',
  'video/x-ms-wmv': 'wmv',
  'audio/x-ms-wma': 'wma',
  'video/x-flv': 'flv',
  'video/quicktime': 'mov',
  'video/webm': 'webm',
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/bmp': 'bmp',
  'image/webp': 'webp',
  'image/svg+xml': 'svg',
  'image/tiff': 'tiff',
  'application/x-rar-compressed': 'rar',
  'audio/mpeg': 'mp3',
  'audio/ogg': 'ogg',
  'audio/wav': 'wav',
  'audio/aac': 'aac',
  'audio/x-aiff': 'aiff',
  'audio/x-flac': 'flac',
  'application/x-shockwave-flash': 'swf',
  'application/x-msdownload': 'exe',
  'application/vnd.android.package-archive': 'apk',
  'application/json': 'json',
  'application/javascript': 'js',
  'application/xml': 'xml',
  'text/html': 'html',
  'application/x-tar': 'tar',
  'application/gzip': 'gz',
  'application/x-7z-compressed': '7z',
  'application/vnd.oasis.opendocument.text': 'odt',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.oasis.opendocument.presentation': 'odp',
  'application/vnd.ms-visio.drawing': 'vsd',
  'application/vnd.ms-visio.viewer': 'vsdx',
  'application/x-font-woff': 'woff',
  'application/x-font-woff2': 'woff2',
  'font/otf': 'otf',
  'font/ttf': 'ttf',
  'application/epub+zip': 'epub',
  'application/x-font-ttf': 'ttf',
  'application/x-mspublisher': 'mspub',
  'application/vnd.ms-access': 'mdb',
};


export { extentions, typeFiles, filesToType }
